import React, { Suspense, useEffect, useState } from 'react';
import { MessagingConfigProvider } from '../contexts/MessagingConfigContext';
import {
  TwilioConversationsContext,
  createConnectingTwilioContext,
  TwilioRuntimeBridgeContext,
  type TwilioConversationsContextType,
} from '../contexts/twilioConversationContext.shared';
import { createRecoverableLazyLoader } from '../utils/chunkErrorHandler';

type Props = {
  identity: string;
  children: React.ReactNode;
};

const TwilioConversationsRuntimeLazy = React.lazy(
  createRecoverableLazyLoader(async () => {
    const mod = await import('../contexts/TwilioConversationsContext');
    return { default: mod.TwilioConversationsRuntime };
  })
);

/**
 * Shell context immédiat ; SDK Twilio lazy à côté (fallback null).
 * Les children restent au même endroit dans l’arbre — pas de remontage au resolve.
 */
export function LazyTwilioMessagingProvider({ identity, children }: Props) {
  const [contextValue, setContextValue] = useState<TwilioConversationsContextType>(() =>
    createConnectingTwilioContext()
  );

  useEffect(() => {
    setContextValue(createConnectingTwilioContext());
  }, [identity]);

  return (
    <MessagingConfigProvider>
      <TwilioConversationsContext.Provider value={contextValue}>
        <TwilioRuntimeBridgeContext.Provider value={setContextValue}>
          {children}
          <Suspense fallback={null}>
            <TwilioConversationsRuntimeLazy identity={identity} />
          </Suspense>
        </TwilioRuntimeBridgeContext.Provider>
      </TwilioConversationsContext.Provider>
    </MessagingConfigProvider>
  );
}
